module.exports = __webpack_public_path__ + "img/justin.ee01520d.png";